/**
 * Única clave de descarga/envío de reportes. Ver también
 * `api/src/shared/permissions/canExportReports.ts` (mismo 403).
 *
 * `reports.compare` solo abre la comparativa; no autoriza export.
 *
 * | CTA | URL | Permiso export | Extra (pantalla / scope) |
 * |---|---|---|---|
 * | Comparativa dashboard | `/` | `reports.export` | ≥2 clínicas |
 * | Pack directorio | `/`, `/finances` | `reports.export` | ≥1 tenant en scope |
 * | Resumen clínica (US-023) | `/clinics/{id}` | `reports.export` | tenant en scope (API) |
 * | Comparativa reportes (canónica) | `/reports/comparison` | `reports.export` | ver página: `reports.compare` |
 * | Tablero consolidado | `/reports/consolidated` | `reports.export` | ver: dashboard/reports |
 * | Caja residual | `/reports/cashflow`, `/finances` | `reports.export` | ver caja: `metrics.caja` |
 * | PVP residual | `/reports/clinic` | `reports.export` | clínica concreta |
 * | Movimientos | `/caja/movimientos?…` | `reports.export` | una clínica, no `all` |
 * | No volvieron | `/patients`, detalle | `reports.export` | `metrics.no_volvieron` |
 * | Recurrencia | `/reports/conversion` | `reports.export` | `metrics.recurrencia` |
 * | Email reporte | cualquier pantalla | `reports.export` | — |
 *
 * Owner: todas las keys. Asistente: solo su clínica (tenant guard), nunca otra.
 */
export const REPORTS_EXPORT_PERMISSION = 'reports.export' as const;

export function canExportReports(hasPermission: (key: string) => boolean): boolean {
  return hasPermission(REPORTS_EXPORT_PERMISSION);
}
